module.exports = __webpack_public_path__ + "media/images/emblems/Thundorf-coat_of_arms-41a2e0bc4928e79e059eeea6bc25280e.svg";